// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Modal_wrapper__3mJSr","title_wrapper":"Modal_title_wrapper__2wbnP","modal":"Modal_modal__3LZrY"};